'use client';

import React from "react";
import { Phone, MessageCircle, ChevronRight } from "lucide-react";
import { StageChip, OverdueBadge, formatDate, formatDateTime } from "./parts";
import { daysLate, needsNextDate, isLiveStage, APPOINTMENT_STAGE } from "./state";

export const EnquiryRow = ({ enquiry, onClick, showOverdue = false }) => {
  const isAppt = enquiry.stage === APPOINTMENT_STAGE;
  return (
    <button
      data-testid={`enquiry-row-${enquiry.id}`}
      onClick={onClick}
      className="flex w-full items-center justify-between rounded-xl border border-zinc-200 bg-white p-4 text-left shadow-sm transition-colors hover:bg-zinc-50"
    >
      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-center gap-2">
          <span className="truncate font-medium text-zinc-900">{enquiry.name}</span>
          {showOverdue && enquiry.next_followup_date && daysLate(enquiry.next_followup_date) >= 0 && (
            <OverdueBadge days={daysLate(enquiry.next_followup_date)} />
          )}
          {needsNextDate(enquiry) && (
            <span data-testid="no-date-flag" className="rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
              No date set
            </span>
          )}
        </div>
        <div className="flex flex-wrap items-center gap-2 text-xs text-zinc-500">
          <span>{enquiry.phone}</span>
          <span>·</span>
          <span>{enquiry.source}</span>
          <span>·</span>
          <StageChip stage={enquiry.stage} />
          {isAppt && enquiry.next_followup_date && (
            <>
              <span>·</span>
              <span className="font-medium text-sky-700">{formatDateTime(enquiry.next_followup_date)}</span>
            </>
          )}
        </div>
      </div>
      <ChevronRight size={18} className="ml-2 shrink-0 text-zinc-400" />
    </button>
  );
};

export const KanbanCard = ({ enquiry, onClick, tourId }) => {
  const isAppt = enquiry.stage === APPOINTMENT_STAGE;
  return (
    <button
      data-testid={`kanban-card-${enquiry.id}`}
      data-tour-id={tourId}
      onClick={onClick}
      className="block w-full rounded-lg border border-zinc-200 bg-white p-2.5 text-left shadow-sm hover:bg-zinc-50"
    >
      <div className="truncate text-sm font-medium leading-tight text-zinc-900">{enquiry.name}</div>
      <div className="mt-0.5 truncate text-xs text-zinc-600">
        {enquiry.enquiry_type}{enquiry.seat_count ? ` · ${enquiry.seat_count}` : ""}
      </div>
      <div className="mt-0.5 truncate text-[11px] text-zinc-500">{enquiry.phone}</div>
      {enquiry.next_followup_date && isLiveStage(enquiry.stage) && (
        <div className={`mt-1 text-[11px] ${isAppt ? "font-medium text-sky-700" : "text-zinc-500"}`}>
          {isAppt ? formatDateTime(enquiry.next_followup_date) : `Next: ${formatDate(enquiry.next_followup_date)}`}
        </div>
      )}
      {needsNextDate(enquiry) && (
        <div className="mt-1 inline-block rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
          No date set
        </div>
      )}
    </button>
  );
};
